import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";

const toUrl = (to) => {
  if (typeof to === "string") {
    return to;
  }
  if (to && typeof to === "object") {
    if (to.pathname && to.search) {
      const search = to.search.startsWith("?") ? to.search : `?${to.search}`;
      return `${to.pathname}${search}`;
    }
    if (to.pathname && to.query) {
      return { pathname: to.pathname, query: to.query };
    }
  }
  return to;
};

const getSearch = (asPath) => {
  const idx = asPath.indexOf("?");
  return idx === -1 ? "" : asPath.slice(idx);
};

export const useLocation = () => {
  const router = useRouter();
  return {
    pathname: router.pathname,
    search: getSearch(router.asPath || ""),
  };
};

export const withRouter = (Component) => (props) => {
  const router = useRouter();
  const history = {
    push: (to) => router.push(toUrl(to)),
    replace: (to) => router.replace(toUrl(to)),
  };
  const location = {
    pathname: router.pathname,
    search: getSearch(router.asPath || ""),
  };

  return (
    <Component
      {...props}
      router={router}
      history={history}
      location={location}
    />
  );
};

export const LinkCompat = ({ to, href, children, ...props }) => {
  const linkHref = href || to;
  return (
    <Link href={linkHref} {...props}>
      {children}
    </Link>
  );
};

export default LinkCompat;
